export default class PatUntersuchung {
    /** PK: Identifikation der Untersuchung zum Patienten | erforderlich **/
    public patuntersuchung_id: number | null = null;
    /** Verweis auf Patienten | erforderlich **/
    public patnr: number | null = null;
    /** Verweis auf Plan **/
    public patplan_id: number | null = null;
    /** Körpergröße des Patienten in [cm] **/
    public koerpergroesse: number | null = null;
    /** Körpergewicht des Patienten in [kg] **/
    public koerpergewicht: number | null = null;
    /** Datum der Probe **/
    public abnahmedatum: string | null = null;
    /** Datum der Laboruntersuchung **/
    public untersuchungsdatum: string | null = null;
    /** FK: PatUntersuchungID der Untersuchung **/
    public untersuchung_id: number | null = null;
    /** Datum der Befunderstellung **/
    public befunddatum: string | null = null;
    /** Befund | max. 1073741823 Zeichen **/
    public befundtext: string | null = null;
    /** neg., pos. oder grenzwertig | max. 15 Zeichen **/
    public befundwerttext: string | null = null;
    /** z.B. 500 **/
    public befundwert: number | string | null = null;
    /** z.B. 500 **/
    public befundwert_char: string | null = null;
    /** Untersuchung verrechnen? | max. 1 Zeichen | erforderlich **/
    public verrechnung: string | null = 'n';
    /** Interpretation des Befundergebnisses | max. 1073741823 Zeichen **/
    public interpretation: string | null = null;
    /** Bei Befunddruck mitberücksichtigen? | max. 1 Zeichen | erforderlich **/
    public druck: string | null = 'n';
    /** Datum der geplanten Untersuchung **/
    public geplant: string | null = null;
    /** Sendezeitpunkt des E-Mails mit Befund **/
    public gesendet: string | null = null;
    /** FK: PatUntersuchungVerweis auf Tab. Personen, durchführende Person (Arzt) **/
    public person_id_arzt: number | null = null;
    public isDirty: boolean| null = null;
    public vergleichsoperator: string| null = null;

    public untersuchung: string | null = null;
    public untersuchung_einheit: string | null = null;
    public untersuchung_preis: number | null = null;
    public untersuchung_steuersatz: number | null = null;
    public untersuchung_verrechnung: string | null = null;
    public untersuchung_untersuchungsbefundvariante: string | null = null;
    public person_arzt: string | null = null;
    public plan_datum: string | null = null;
    public hcw: string | null = 'n';

    public patplanimpfstoff_id: number | null = null;

    public untersuchungen: number[] = [];

    public get befundergebnis(): string {
        return [
            this.befundwerttext,
            this.befundwertMitEinheit,
        ].filter(value => value).join(' ');
    }

    public get befundergebnisVariiert(): string {
        return [
            this.befundwerttext,
            this.befundwertMitEinheitVariiert,
        ].filter(value => value).join(' ');
    }

    public get befundwertMitEinheit(): string | null {
        if (this.befundwert === null) {
            return null;
        }

        const befundwert = typeof this.befundwert === 'string'
            ? this.befundwert
            : this.befundwert.toLocaleString('de-DE');

        return [this.Vergleichsoperator(this.vergleichsoperator), befundwert, this.untersuchung_einheit ?? ''].join(' ');
    }

    public get befundwertMitEinheitVariiert(): string | null {
        if (this.befundwert_char) {
            return this.befundwert_char;
        }

        if (this.befundwert === null) {
            return null;
        }

        const befundwert = typeof this.befundwert === 'string'
            ? this.befundwert
            : this.befundwert.toLocaleString('de-DE');

        return [this.Vergleichsoperator(this.vergleichsoperator), befundwert, this.untersuchung_einheit ?? ''].join(' ');
    }

    public Vergleichsoperator(vergleichsoperator:string| null): string {
        if (vergleichsoperator === '1') {
            return '>';
        } else if (vergleichsoperator === '2') {
            return ' ';
        } else if (vergleichsoperator === '3') {
            return '<';
        } else if (vergleichsoperator === '4') {
            return '>=';
        } else if (vergleichsoperator === '5') {
            return '<=';
        } else {
            return '';
        }
    }

    public get isGeplant(): boolean {
        return !this.abnahmedatum && this.patplan_id !== null && this.person_id_arzt === null;
        //return this.patplan_id !== null && this.person_id_arzt === null && !this.isAltsystem;
    }

    public get isAltsystem(): boolean {
        type TableRow = this & { fw_created: string | null };
        return (this as TableRow).fw_created === null;
    }

    constructor(untersuchung?: Partial<PatUntersuchung | null>) {
        Object.assign(this, untersuchung);
    }
}
